import { Mail, MessageSquare, ArrowRightLeft, FileText } from 'lucide-react';

interface Activity {
  id: string;
  prospect_id: string;
  type: string;
  content: string;
  created_by: string | null;
  created_at: string;
}

interface ActivityTimelineProps {
  activities: Activity[];
}

const typeIcon = (type: string) => {
  switch (type) {
    case 'email_drafted': return <Mail className="w-3.5 h-3.5" />;
    case 'follow_up_drafted': return <Mail className="w-3.5 h-3.5" />;
    case 'status_change': return <ArrowRightLeft className="w-3.5 h-3.5" />;
    case 'note': return <MessageSquare className="w-3.5 h-3.5" />;
    default: return <FileText className="w-3.5 h-3.5" />;
  }
};

const typeLabel = (type: string) => {
  switch (type) {
    case 'email_drafted': return 'Email drafted';
    case 'follow_up_drafted': return 'Follow-up drafted';
    case 'status_change': return 'Status changed';
    case 'note': return 'Note added';
    default: return type;
  }
};

const ActivityTimeline = ({ activities }: ActivityTimelineProps) => {
  if (activities.length === 0) {
    return <p className="text-sm text-muted-foreground italic">No activity yet.</p>;
  }

  return (
    <div className="space-y-3">
      {activities.map((a) => (
        <div key={a.id} className="flex gap-3">
          <div className="flex flex-col items-center">
            <div className="w-7 h-7 rounded-full bg-muted flex items-center justify-center text-muted-foreground shrink-0">
              {typeIcon(a.type)}
            </div>
            <div className="w-px flex-1 bg-border" />
          </div>
          <div className="pb-4 flex-1 min-w-0">
            <div className="flex items-center gap-2 text-xs text-muted-foreground mb-0.5">
              <span className="font-medium text-foreground">{typeLabel(a.type)}</span>
              {a.created_by && <span>by {a.created_by}</span>}
              <span>·</span>
              <span>{new Date(a.created_at).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' })}</span>
            </div>
            <p className="text-sm text-foreground whitespace-pre-wrap">{a.content}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ActivityTimeline;
export type { Activity };
